import { useHistory, useLocation } from 'react-router';
import { useCallback, useEffect } from 'react';

export const useUrlDependedBoolean = (name: string): [boolean, () => void] => {
  const history = useHistory();
  const { search, pathname } = useLocation();

  const value = new URLSearchParams(search).get(name);

  const onChange = useCallback(() => {
    if (value) {
      history.push(pathname);
    } else {
      history.push('?' + name + '=active');
    }
  }, [history, name, pathname, value]);

  return [!!value, onChange];
};
